<el-main class="main">
  <div class="form">
    <div class="module module-header">
      <h1
        class="header-form"
        v-if="dataForm.applicationCargoPickup.isCargoPickup"
      >
        Оформление заявки на забор груза
      </h1>
      <h1 class="header-form" v-else>
        Оформление экспедиторской расписки перед отправкой
      </h1>
    </div>
    <el-form
      class="module"
      label-position="top"
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
    >
      <el-tabs v-model="formTabs.activeName" class="demo-tabs">
        <el-tab-pane
          label="Данные контрагентов"
          name="cargo-transportation-customer"
        >
          <div class="tab-container">
            <SenderPartial
              :cities="cities"
              :is-cargo-pickup="true"
              @click-button-back="clickFormButtonBack"
            />
            <ConsigneePartial :cities="cities" :is-cargo-pickup="true" />
            <ThirdPersonPartial
              @click-button-back="clickFormButtonBack"
              @click-button-next="clickFormButtonNext"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="Информация о грузе" name="cargo-information" :disabled="checkDisabledTab('cargo-information')">
          <CargoInformationPartial
            @click-button-back="clickFormButtonBack"
            @click-button-next="clickFormButtonNext"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Информация о заборе/доставке"
          name="application-cargo-pickup"
          :disabled="checkDisabledTab('application-cargo-pickup')"
        >
          <ApplicationCargoPickupPartial
            @click-button-back="clickFormButtonBack"
            @click-button-next="clickFormButtonNext"
          />
        </el-tab-pane>
        <el-tab-pane label="Доп. услуги" name="services" :disabled="checkDisabledTab('services')" >
          <ServicesPartial
            @click-button-back="clickFormButtonBack"
            @click-button-next="clickFormButtonNext"
          />
        </el-tab-pane>
        <el-tab-pane label="Оплата" name="payment" :disabled="checkDisabledTab('payment')">
          <PaymentPartial
            @click-button-back="clickFormButtonBack"
            @submit-form-sender="submitFormSender"
            :ruleFormRef="ruleFormRef"
          />
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        v-model="alertOfApplicationSubmission.isVisiblePrint"
        title="Уважаемый клиент!"
        class="dialog"
        center
      >
        <div class="print-container">
          <template v-if="alertOfApplicationSubmission.pickupDate">
            <span class="span_padding-bottom--8px"
              >От Вас поступила заявка на забор груза</span
            >
            <span class="span_padding-bottom--8px"
              ><strong
                >№{{ alertOfApplicationSubmission.numberApplication }}</strong
              ></span
            >

            <span class="span_padding-bottom--8px"
              >Курьер подъедет в указанное Вами время:</span
            >
            <span class="span_padding-bottom--8px"
              >{{ alertOfApplicationSubmission.pickupDate }}</span
            >
            <span class="span_padding-bottom--8px"
              >с {{ alertOfApplicationSubmission.cargoStartTimePickup }} до {{
              alertOfApplicationSubmission.cargoEndTimePickup }}</span
            >

            <span>Просьба упаковать и промаркировать груз перед отправкой</span>
          </template>

          <template v-else>
            <span class="span_padding-bottom--8px"
              >Вами сформирована экспедиторская расписка</span
            >
            <span class="span_padding-bottom--8px"
              ><strong
                >№{{ alertOfApplicationSubmission.numberApplication }}</strong
              ></span
            >
            <span class="span_padding-bottom--8px"
              >От {{ alertOfApplicationSubmission.createTime.day }}/{{ parseDate(Number(alertOfApplicationSubmission.createTime.month) + 1) }}/{{ alertOfApplicationSubmission.createTime.year }}</span>

            <span
              >Продиктуйте последние 7 цифр на приёмке склада при сдаче
              груза</span
            >
          </template>
        </div>
        <div class="button_container">
            <el-button
              class="button__send"
              @click="onPrint"
              type="primary"
              :icon="Printer"
              >{{ isRaspiska ? "Печать экспедиторской расписки" : "Печать транспортной накладной" }}</el-button
            >
            <el-button
              class="button__send"
              @click="onMarkingCardPrint"
              type="primary"
              :icon="Printer"
              >Печать маркировочных талонов</el-button
            >
            <el-button
              @click="closePrintingModal"
              type="primary"
              >Закрыть</el-button
            >
          </div>
      </el-dialog>
    </el-form>
  </div>
</el-main>
